import React from 'react';
import { ModalProps } from '../../types/modal';
import { SetMenu } from '../../types/set-menu';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Stack,
    Typography,
} from '@mui/material';
import SetMenuPreview from './SetMenuPreview';
import { CustomButton } from '../../../layout/styledcomponents/CustomButton';
import { Close, Edit } from '@mui/icons-material';

interface SetMenuPreviewModalProps extends ModalProps {
    setMenu: SetMenu | null;
    handleEdit: () => void;
}

const SetMenuPreviewModal = ({
    open,
    onClose,
    handleEdit,
    setMenu,
}: SetMenuPreviewModalProps) => {
    if (!setMenu) return null;

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth='md'>
            <DialogTitle>
                Set Menu Preview
                <IconButton
                    onClick={onClose}
                    sx={{ color: 'text.primary' }}
                    aria-label='close'
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ maxHeight: '600px', overflow: 'auto' }}>
                <Stack spacing={1}>
                    <Typography variant='subtitle2'>
                        Here is how your set menu will appear to hosts:
                    </Typography>
                    <SetMenuPreview setMenu={setMenu} />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button
                    variant='outlined'
                    startIcon={<Edit />}
                    onClick={handleEdit}
                >
                    Edit Set Menu
                </Button>
                <CustomButton
                    variant='contained'
                    color='primary'
                    onClick={onClose}
                >
                    Close
                </CustomButton>
            </DialogActions>
        </Dialog>
    );
};

export default SetMenuPreviewModal;
